import React from 'react';
import { getFormAnswerKeyEntries } from '../../utils/formAnswerKeyDisplay';

function formatAnswerText(entry) {
  if (entry.chips.length > 0) {
    return entry.chips.map((chip) => chip.text).join(', ');
  }
  return entry.detail || entry.modeLabel;
}

const AssignmentAnswerKeyPanel = ({ form }) => {
  const entries = getFormAnswerKeyEntries(form);

  if (entries.length === 0) {
    return <p className="profile-assignment-viewer__hint">No keyed answers for this form.</p>;
  }

  return (
    <ul className="assignment-answer-key">
      {entries.map((entry) => (
        <li key={entry.id} className="assignment-answer-key__item">
          <span className="assignment-answer-key__num">{entry.index}.</span>
          <span className="assignment-answer-key__text">{formatAnswerText(entry)}</span>
        </li>
      ))}
    </ul>
  );
};

export default AssignmentAnswerKeyPanel;
